/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

 import React from "react"
 import PropTypes from "prop-types"
 import Helmet from "react-helmet"
 import favicon from '../images/favicon_io/favicon.ico'
 import { useStaticQuery, graphql } from "gatsby"
  
 const SEO = ({ description, lang, meta, title, keywords }) => {
   const { site } = useStaticQuery(
     graphql`
       query {
         site {
           siteMetadata {
             title
             description
           }
         }
       }
     `
   )
 
   const metaDescription = description || site.siteMetadata.description
 
   return (
     <Helmet
       htmlAttributes={{
         lang,
       }}
       link={[
       { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }
       ]}
       title={title}
       titleTemplate={`%s | ${site.siteMetadata.title}`}
       meta={[
         {
           name: `description`,
           content: metaDescription,
         },
         { name: `keywords`,
           content: keywords,
         },
         {
           property: `og:title`,
           content: title,
         },
         {
           property: `og:description`,
           content: metaDescription,
         },
         {
           property: `og:type`,
           content: `website`,
         },
         {
           property: `og:image`,
           content: `https://i.imgur.com/bb2nnCk.png`,
         },
         {
           property: `og:image:width`,
           content: `313`,
         },
         {
           property: `og:image:height`,
           content: `156`,
         },
         {
           property: `og:url`,
           content: `https://www.dreamcraft.com`,
         },
         {
           property: `og:site_name`,
           content: `dreamcraft.com`,
         },
         {
           name: `twitter:card`,
           content: `summary`,
         },
         {
           name: `twitter:title`,
           content: title,
         },
         {
           name: `twitter:description`,
           content: metaDescription,
         },
         {
           name: `twitter:image`,
           content: `https://i.imgur.com/bb2nnCk.png`
         },
         {
           name: `twitter:url`,
           content: `https://www.dreamcraft.com`
         }
       ].concat(meta)}
     />
   )
 }
 
 SEO.defaultProps = {
   lang: `en`,
   meta: [],
   description: ``,
 }
 
 SEO.propTypes = {
   description: PropTypes.string,
   lang: PropTypes.string,
   meta: PropTypes.arrayOf(PropTypes.object),
   title: PropTypes.string.isRequired,
 }
 
 export default SEO